import { BiUploadedDatasetView } from '@euler/model/bi/dataset';
import { BiDatasetSection } from '@euler/model/bi/library';
import { BiDatasetRefKind } from '@euler/model/bi/query';
import { BiService } from '@euler/services/bi.service';

/**
 * The uploaded datasets the caller can use: their own, then those shared
 * with them, each once.
 */
export async function fetchBiUsableUploads(
  biService: BiService,
): Promise<BiUploadedDatasetView[]> {
  const lists = await Promise.all([
    biService.listDatasets({ section: BiDatasetSection.Mine }),
    biService.listDatasets({ section: BiDatasetSection.Shared }),
  ]);
  const seen = new Set<string>();
  return lists.flatMap(list =>
    list.datasets.flatMap(entry => {
      if (entry.kind !== BiDatasetRefKind.Upload) return [];
      if (seen.has(entry.dataset.id)) return [];
      seen.add(entry.dataset.id);
      return [entry.dataset];
    }),
  );
}
